import { WSElement } from "@wingspanhq/fe-component-library";
import styles from "./WalletCardSkeleton.module.scss";

export const WalletCardSkeleton: React.FC = () => (
  <WSElement shimmer className={styles.skeleton} />
);
